export default {
  title: 'Examples',
  img: 'demo',
  subsections: [
    {
      title: 'Python (requests)',
      icon: 'https://cdn3.iconfinder.com/data/icons/logos-and-brands-adobe/512/267_Python-512.png',
      content: [
        {
          tag: 'example',
          content: `import requests<br/>url = "https://api-pro.breezi.net/measurements/AP000000"<br/><br/>headers = {<br/>&nbsp;&nbsp;&nbsp;'x-api-key': "{yourApiKey}",<br/>&nbsp;&nbsp;&nbsp;'content-type': "application/json"<br/>}<br/>response = requests.request("GET", url, headers=headers)<br/>print(response.text)`
        }
      ]
    },
    {
      title: 'nodejs (request)',
      icon: 'https://cdn.pixabay.com/photo/2015/04/23/17/41/node-js-736399_960_720.png',
      content: [
        {
          tag: 'example',
          content: `var request = require("request");<br/>var options = {<br/>&nbsp;&nbsp;&nbsp;method: 'GET',<br/>&nbsp;&nbsp;&nbsp;url: 'https://api-pro.breezi.net/measurements/AP000000',<br/>&nbsp;&nbsp;&nbsp;headers: {<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;'content-type': 'application/json',<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;'x-api-key': '{yourApiKey}' <br/>&nbsp;&nbsp;&nbsp;} <br/>};<br/>request(options, function (error, response, body) {<br/>&nbsp;&nbsp;&nbsp;if (error) throw new Error(error);<br/>&nbsp;&nbsp;&nbsp;console.log(body);<br/>});`
        }
      ]
    },
    {
      title: 'jQuery',
      icon: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRlJEL4F-IqROVTyPGQAosbmqVPxYusr8TWgQ&usqp=CAU',
      content: [
        {
          tag: 'example',
          content: `var settings = {</br>&nbsp;&nbsp;&nbsp;"async": true,</br>&nbsp;&nbsp;&nbsp;"crossDomain": true,</br>&nbsp;&nbsp;&nbsp;"url": "https://api-pro.breezi.net/measurements/AP000000"",</br>&nbsp;&nbsp;&nbsp;"method": "GET",</br>&nbsp;&nbsp;&nbsp;"headers": {</br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"x-api-key": "{yourApiKey}",</br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"content-type": "application/json"</br>&nbsp;&nbsp;&nbsp;}</br>}</br>$.ajax(settings).done(function (response) {</br>&nbsp;&nbsp;&nbsp;console.log(response);</br>});`
        }
      ]
    },
    {
      title: 'PHP (cURL)',
      icon: 'https://www.freepnglogos.com/uploads/php-logo-png/php-logo-png-transparent-svg-vector-bie-supply-1.png',
      content: [
        {
          tag: 'example',
          content: `<?php<br/>$curl = curl_init();<br/>curl_setopt_array($curl, array(<br/>&nbsp;&nbsp;&nbsp;CURLOPT_URL => "https://api-pro.breezi.net/measurements/AP000000",<br/>&nbsp;&nbsp;&nbsp;CURLOPT_RETURNTRANSFER => true,<br/>&nbsp;&nbsp;&nbsp;CURLOPT_ENCODING => "",<br/>&nbsp;&nbsp;&nbsp;CURLOPT_MAXREDIRS => 10,<br/>&nbsp;&nbsp;&nbsp;CURLOPT_TIMEOUT => 30,<br/>&nbsp;&nbsp;&nbsp;CURLOPT_HTTP_VERSION => CURL_HTTP_VERSION_1_1,<br/>&nbsp;&nbsp;&nbsp;CURLOPT_CUSTOMREQUEST => "GET",<br/>&nbsp;&nbsp;&nbsp;CURLOPT_HTTPHEADER => array(<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"content-type: application/json",<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"x-api-key: {yourApiKey}"<br/>&nbsp;&nbsp;&nbsp;),<br/>));<br/>$response = curl_exec($curl);<br/>$err = curl_error($curl);<br/>curl_close($curl);<br/>if ($err) {<br/>&nbsp;&nbsp;&nbsp;echo "cURL Error #:" . $err;<br/>} else {<br/>&nbsp;&nbsp;&nbsp;echo $response;<br/>}`
        }
      ]
    },
    {
      title: 'Ruby',
      icon: 'https://upload.wikimedia.org/wikipedia/commons/thumb/7/73/Ruby_logo.svg/1024px-Ruby_logo.svg.png',
      content: [
        {
          tag: 'example',
          content: `require 'uri'<br/>require 'net/http'<br/>url = URI("https://api-pro.breezi.net/measurements/AP000000")<br/>http = Net::HTTP.new(url.host, url.port)<br/>http.use_ssl = true<br/>http.verify_mode = OpenSSL::SSL::VERIFY_NONE<br/>request = Net::HTTP::Get.new(url)<br/>request["x-api-key"] = '{yourApiKey}}'<br/>request["content-type"] = 'application/json'<br/>response = http.request(request)<br/>puts response.read_body`
        }
      ]
    },
    {
      title: 'Java (unirest)',
      icon: 'https://cdn-icons-png.flaticon.com/512/226/226777.png',
      content: [
        {
          tag: 'example',
          content: `HttpResponse<String> response = Unirest.get("https://api-pro.breezi.net/measurements/AP000000")<br/>&nbsp&nbsp&nbsp.header("x-api-key", "{yourApiKey}")<br/>&nbsp&nbsp&nbsp.header("content-type", "application/json")<br/>&nbsp&nbsp&nbsp.asString();`
        }
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/lib/apiDocTemplates/demo.js